module.exports = __webpack_public_path__ + "static/media/logo long.e0a955b4.svg";